<template>
  <div class="is-border">

    <contrat  class="is-paddingless"
                  :source="adv"
                  :lot="lot"
                  :program="program"
                  :seller="seller"
                  :buyer="buyer"
                  :co-buyers="coBuyers"
                  @commit="commitAdv"></contrat>

    <financement  class="is-paddingless"
                  :source="adv"
                  :lot="lot"
                  :program="program"
                  :seller="seller"
                  :buyer="buyer"
                  :co-buyers="coBuyers"
                  @commit="commitAdv"></financement>

    <notaire  class="is-paddingless is-two-thirds"
              :source="adv"
              :lot="lot"
              :program="program"
              :seller="seller"
              :buyer="buyer"
              :co-buyers="coBuyers"
              @commit="commitAdv"></notaire>

    <vente-actee class="is-paddingless is-two-thirds"
                 v-if="venteActee"
                 :source="adv"
                 :lot="lot"
                 :program="program"
                 :seller="seller"
                 :buyer="buyer"
                 :co-buyers="coBuyers"
                 @commit="commitAdv"></vente-actee>

    <div v-if="livraison" class="column">
      <h2 class="title"><strong>Livraison</strong></h2>
    </div>
    <div v-if="livraison" class="columns">
      <div class="column is-two-thirds is-padding-top-xsmall">
        <table class="table is-std is-form is-border full-width is-margin-top-small is-first-fixed-xsmall">
          <thead>
          <tr class="is-light is-size-7 is-uppercase">
            <th>&nbsp;</th>
            <th>Date de pré-réception</th>
            <th>Date de livraison client</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class="picto-etat">
              <input id="livraisonCheck" name="livraisonCheck"
                     disabled="disabled"
                     :checked="livraisonCheck"
                     class="is-checkradio is-circle is-success"
                     type="checkbox">
              <label for="livraisonCheck" class="is-paddingless-left is-paddingless-right"></label>
            </td>
            <td>
              <span v-if="adv.livraison.date_pre_reception">{{adv.livraison.date_pre_reception|date}}</span>
            </td>
            <td>
              <span v-if="adv.contrat_de_reservation.date_livraison_client">{{adv.contrat_de_reservation.date_livraison_client|date}}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="formActionsSticky is-bottom" v-if="canEdit && pendingEdition">
      <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <button class="button is-light is-uppercase is-fullwidth" @click="backToInitialAdv">Annuler</button>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button class="button is-success is-uppercase is-fullwidth has-text-white" @click="saveAdv">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                  mode="out-in">
              <div v-if="saving" key="saving" class="veryFastAnimation" is-success>
                <span class="has-text-black">Enregistrement...</span>
              </div>
              <div v-else key="not-saving" class="veryFastAnimation">
                <span>Enregistrer</span>
              </div>
            </transition>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '@/mixins'
  import { isNil, debounce, isEmpty } from 'lodash'
  import moment from 'moment'
  import Contrat from '../FeuilleDeRoute/ContratDeReservation'
  import Financement from '../FeuilleDeRoute/Financement'
  import Notaire from '../FeuilleDeRoute/Notaire'
  import VenteActee from '../FeuilleDeRoute/VenteActee'

  export default {
    name: 'AdvRecap',
    mixins: [AdvMx],
    props: {},
    components: { Notaire, Contrat, Financement, VenteActee },
    data () {
      return {
        reservationDate: null,
        debutDeVenteAnnoncee: null,
        accuseDeReception: []
      }
    },
    computed: {
      firstAccuseDeReceptionFile () {
        if (this.contrat && this.accuseDeReception && this.accuseDeReception.length > 0) {
          return this.accuseDeReception[0]
        }
        return null
      },
      contratDeReservationCheck () {
        return this.contrat && this.contrat.debut_de_vente_annoncee && this.firstAccuseDeReceptionFile && this.firstAccuseDeReceptionFile.dossier_envoyes
      },
      venteActeeCheck () {
        return this.adv.sale_date
      },
      livraisonCheck () {
        return this.adv.contrat_de_reservation.date_livraison_client && this.adv.livraison.date_pre_reception
      }
    },
    methods: {
      updateReservationDate (values, value) {
        if (isNil(value) || value.length === 0) {
          return
        }
        let date = values[0]
        // let save = this.adv.reservation_date !== moment(date).format('DD/MM/YYYY')
        this.adv.reservation_date = moment.utc(date).format('DD/MM/YYYY HH:mm')
        this.commitAdv()
      },
      updateDebutDeVenteAnnoncee (value) {
        if (isNil(value) || value.length === 0) {
          return
        }
        let date = value[0]
        let save = this.adv.contrat_de_reservation.debut_de_vente_annoncee !== moment(date).format('DD/MM/YYYY')
        this.adv.contrat_de_reservation.debut_de_vente_annoncee = moment(date).format('DD/MM/YYYY')
        this.commitAdv(save)
      },
      commitAdv: debounce(function (editedAdv, save = true) {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.contrat_de_reservation, 'accuse_de_reception', this.accuseDeReception)
        this.$set(adv.contrat_de_reservation, 'documents', this.contratDeReservationDocuments)
        let _this = this
        _this.$emit('commit', adv, save)
      }, 500),
      initAccuseDeReception () {
        if (isNil(this.contrat) || isNil(this.contrat.accuse_de_reception) || isEmpty(this.contrat.accuse_de_reception)) {
          return {
            check: false,
            status: 'not_valid',
            dossier_envoyes: null,
            numero_ar: null,
            presentation_ar: null,
            reception_ar: null
          }
        } else if (this.contrat.accuse_de_reception && Array.isArray(this.contrat.accuse_de_reception) && this.contrat.accuse_de_reception.length) {
          return Object.assign({}, this.contrat.accuse_de_reception[0])
        } else {
          return Object.assign({}, this.contrat.accuse_de_reception)
        }
      }
    },
    created () {
      this.accuseDeReception = this.initAccuseDeReception()
      this.reservationDate = moment.utc(this.adv.reservation_date).toDate()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Details/AdvRecap.vue